<template>
  <a-config-provider :locale="locale">

    <div id="app">
      <router-view name="header"></router-view>
      <router-view name="default"></router-view>
      <router-view name="footer"></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'app',
  components: {},
  data() {
    return {
      locale:zhCN
    };
  }
}
</script>
